module.exports = __webpack_public_path__ + "static/img/3f14f58d-88d7-4511-98ea-d55f6a407031.481dc66.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banners/3f14f58d-88d7-4511-98ea-d55f6a407031.png
// module id = 6PB3
// module chunks = 0